import { CONDITION_OPERATOR } from 'moet-core/src/flow';

export const or = (...conditions) => ({ operator: CONDITION_OPERATOR.OR, conditions });

export const not = condition => {
  if (condition == null) {
    console.warn('Condition operator NOT expects another condition as param, but none was passed.');
    return true;
  }
  return { operator: CONDITION_OPERATOR.NOT, conditions: [condition] };
};
